import $ from 'jquery';

const settings = {
  selectors: {
    controller: document.body,
    menu: '.menu-icon',
  },
};

export default class Toolbar {
  constructor(element, context) {
    this.context = context;
    this.element = element;
    this.settings = settings;
    this.$element = $(element);
    this.$menuBtn = this.getBtn('menu');
    this.$controller = this.getController();
    this.handler = this.handler.bind(this);
    this.listen();
  }

  getBtn(type) {
    return this.$element.find(this.settings.selectors[type]);
  }

  getController() {
    return $(this.settings.selectors.controller, this.context);
  }

  handler() {
    return this.$controller.is('.menu-active') ? this.blur() : this.focus();
  }

  blur() {
    this.$controller.removeClass('menu-active search-active');
  }

  focus() {
    this.$controller.addClass('menu-active');
  }

  listen() {
    this.$menuBtn.on('click', this.handler);
  }
}
